module.exports = __webpack_public_path__ + "img/Rectangle 22.511f5128.png";